customElements.define(
  'subscription-summary',
  class SubscriptionSummary extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        "itemRemove": "[data-item-remove]",
        "itemRemoveData": "itemRemove",
        "summaryOverlay": "[data-summary-overlay]",
        "summaryHeader": "[data-summary-header]",
        "summaryHeaderPrice": "[data-summary-header-price]",
        "summaryHeaderCounter": "[data-summary-header-counter]",
        "summaryContent": "[data-summary-content]",
        "summaryClose": "[data-summary-close]",
        "continueShoppingAbonnement": "[data-continue-shopping-abonnement]",
        "dropdown": "#dropbox",
        "selectBox": "select.abonnement-summary__select-box",
        "selection": "#selected_title",
        "summaryEmpty": "[data-summary-empty]",
        "summaryNonEmpty": "[data-summary-non-empty]",
        "summaryLineItems": "[data-summary-line-items]",
        "summaryButtonAddToCart": "[data-summary-button-add-to-cart]",
        "abonnementProduct": ".abonnement-product",
      };

      this.selectors = selectors;

      this.summaryOverlay = this.querySelector(this.selectors.summaryOverlay);
      this.summaryHeader = this.querySelector(this.selectors.summaryHeader);
      this.summaryHeaderPrice = this.querySelector(this.selectors.summaryHeaderPrice);
      this.summaryHeaderCounter = this.querySelector(this.selectors.summaryHeaderCounter);
      this.summaryContent = this.querySelector(this.selectors.summaryContent);
      this.summaryClose = this.querySelector(this.selectors.summaryClose);
      this.continueShoppingAbonnement = this.querySelector(this.selectors.continueShoppingAbonnement);
      this.dropdown = this.querySelector(this.selectors.dropdown);
      this.selectBox = this.querySelector(this.selectors.selectBox);
      this.selection = this.querySelector(this.selectors.selection);
      this.summaryEmpty = this.querySelector(this.selectors.summaryEmpty);
      this.summaryNonEmpty = this.querySelector(this.selectors.summaryNonEmpty);
      this.summaryLineItems = this.querySelector(this.selectors.summaryLineItems);
      this.summaryButtonAddToCart = this.querySelector(this.selectors.summaryButtonAddToCart);
      this.abonnementProducts = document.querySelectorAll(this.selectors.abonnementProduct);

      this.subcriptions = [];
      this.frequency = null;
      this.initCookie();
      this.init();
      this.checkUrl();
      this.initFrequenciesSelect();
      
      var self = this;
      // important
      this.summaryButtonAddToCart.addEventListener('click', function(e){
        self.addToCart();
        self.summaryButtonAddToCart.classList.add('loading');
        self.summaryClose.click();
        
        // let itemRemoval = self.summaryLineItems.querySelectorAll('[data-item-remove]');
        // for (let i = 0; i < itemRemoval.length; i++) {
        //   const _itemRemoval = itemRemoval[i];
        //   _itemRemoval.click();
        // }
      });

    //   function scrollTo(element) {
    //     window.scroll({
    //       behavior: 'smooth',
    //       left: 0,
    //       top: element.offsetTop - 100
    //     });
    //   }
    
    // if (window.location.href.indexOf("&categorie=") > -1 && window.location.href.indexOf("?type=") > -1) {
    //       setTimeout(() => {
    //       scrollTo(document.getElementById("section-abonnement-tags"));
    //       console.log('click')
    //       }, 1300);   
          
    // }

      document.querySelector('.product__tooltiptext .close').addEventListener('click', function(){
        document.querySelector('.product__tooltiptext').classList.remove('active');
      })

      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        this.summaryHeader.addEventListener('click', function(e){
          self.openSummaryMobile(e.target);
        });
        this.summaryOverlay.addEventListener('click', function(e){
          self.closeSummaryMobile();
        });
        this.summaryClose.addEventListener('click', function(e){
          self.closeSummaryMobile();
          let url = window.location.search;
          let urlParams = new URLSearchParams(url);
        });
        this.continueShoppingAbonnement.addEventListener('click', function(e){
          self.closeSummaryMobile();
          // setTimeout(() => {
          //   // document.getElementById("abonnement-tags__header").scrollIntoView();
          //   const id = 'abonnement-tags__header';
          //   const yOffset = -100; 
          //   const element = document.getElementById(id);
          //   const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          //   window.scrollTo({top: y, behavior: 'smooth'});
          // }, 1000);
        });
      }


      
    }

    checkUrl() {
      let url = window.location.search;
      let urlParams = new URLSearchParams(url);

      if(urlParams.has('type')) {
        var urlVariantType = urlParams.get('type');
        document.querySelectorAll('.abonnement-type').forEach((item) => {
          var tags = item.value.split(',');
          if (tags.includes(urlVariantType)) {
            if (!item.checked) {
              item.click();
            }
          } else {
            item.checked = false;
          }
        });
      }

      if(urlParams.has('categorie')) {
        var urlVariantCategorie = urlParams.get('categorie');
        document.querySelectorAll('.abonnement-categorie').forEach((item) => {
          var tags = item.value.split(',');
          if (tags.includes(urlVariantCategorie)) {
            if (!item.checked) {
              item.click();
            }
          } else {
            item.checked = false;
          }
        });
      }

      if(urlParams.has('variant')) {
        var urlVariantId = urlParams.get('variant');
        var urlVariantQuantity = urlParams.get('quantity');

        var urlVariantInput = document.querySelector('[data-product-variant-input][value="' + urlVariantId + '"]');
        var urlVariantProduct = document.querySelector('[data-product-variant-input][value="' + urlVariantId + '"]').parentElement.parentElement;

        document.querySelector('subscription-summary').updateSubscriptionSummary(urlVariantId, urlVariantQuantity, {
          title: urlVariantInput.parentElement.parentElement.querySelector('.abonnement-product__title').innerHTML.replace(/<\/?[^>]+(>|$)/g, ""),
          variant_name: urlVariantInput.nextElementSibling.querySelector('span.option2').innerHTML,
          vendor: urlVariantInput.parentElement.parentElement.querySelector('.abonnement-product__vendor').innerHTML,
          unit_price: urlVariantInput.nextElementSibling.querySelector('span.price1').getAttribute('data-subscription-price-float'),
          unit_price_onetime: urlVariantInput.nextElementSibling.querySelector('span.price2').getAttribute('data-variant-price-float'),
          test: 'test',
          sellings_plan: JSON.parse(urlVariantInput.parentElement.parentElement.getAttribute("data-abonnement-product-selling-plans")).sellings_plan,
      
        });

        document.querySelector('[data-summary-header-counter]').innerHTML = '(' + document.querySelector('[data-summary-header-counter]').innerHTML.replace('(', '').replace(')', '').replace(/^0+/, '') + ')';
        setTimeout(() => {
          document.querySelector('[data-summary-header]').click();
        }, 1000);

        window.addEventListener("DOMContentLoaded", (event) => {
        
          function scrollTo(element) {
            window.scroll({
              behavior: 'smooth',
              left: 0,
              top: element.offsetTop - 100
            });
          }
          setTimeout(() => {
            scrollTo(document.getElementById("section-abonnement-tags"));
            console.log('scroll')
          }, 1300);


        });
      }
    }

    init() {

      var self = this;
      this.itemRemoves = this.querySelectorAll(this.selectors.itemRemove); 
      this.itemRemoves.forEach((itemRemove) => {
        itemRemove.addEventListener('click', function(e){
          self.updateSubscriptionSummary(e.currentTarget.dataset[self.selectors.itemRemoveData], 0);
        });
      });
      

    }

    initCookie() {
      if (getCookie('subscriptionsCookie')) {
        this.subcriptions = JSON.parse(getCookie('subscriptionsCookie'));
        this.generateFront();
        setTimeout(() => {
          if (document.querySelectorAll('.abonnement-summary__header.active').length > 0) {
            document.querySelector('.abonnement-summary__header.active').click();
          }
        }, 500);
      }
    }

    updateSubscriptionSummary(variant_id, quantity, product_infos) {
      var subscriptionsContainsVariantID = false;
      var subscriptionIndex = null;
      for (let index = 0; index < this.subcriptions.length; index++) {
        if(variant_id == this.subcriptions[index].variant_id) {
          subscriptionsContainsVariantID = true;
          subscriptionIndex = index;
        }
      }

      if (subscriptionsContainsVariantID) {
        if (quantity == 0) {
          let removedSub = this.subcriptions.splice(subscriptionIndex, 1);
          this.snowplowUpdateCart(removedSub[0].product_infos.handle, removedSub[0].product_infos.sku, removedSub[0].quantity, true, true)
        } else {
          this.subcriptions[subscriptionIndex].quantity += quantity;
        }
      } else {
        var subscription = {
          "variant_id": variant_id,
          "quantity": quantity,
          "product_infos": product_infos
        };
        this.subcriptions.push(subscription);
      }

      this.generateFront();
      this.init();
      this.refreshFrequencies();



      deleteCookie('subscriptionsCookie');
      setCookie('subscriptionsCookie', JSON.stringify(this.subcriptions), 5);
      
    }

    generateFront() {
      //mettre à jour les items
      //mettre le prix
      

      if (this.subcriptions.length == 0) {
        this.summaryEmpty.classList.remove('hide');
        this.summaryNonEmpty.classList.add('hide');
        this.summaryHeader.classList.remove('active');
        this.summaryHeaderPrice.innerHTML = "";
        this.summaryHeaderCounter.innerHTML = "(0)";
      } else {
        this.summaryEmpty.classList.add('hide');
        this.summaryNonEmpty.classList.remove('hide');
        if (!this.summaryContent.classList.contains("active")) {
          this.summaryHeader.classList.add('active');
        }

        this.summaryLineItems.innerHTML = "";

        var all_quantities = 0;

        var all_prices = 0;
        var all_full_prices = 0;
        

        for (let index = 0; index < this.subcriptions.length; index++) {
          var subscription = this.subcriptions[index];
          all_quantities = Number(all_quantities) + Number(subscription.quantity);
          all_prices = all_prices + subscription.quantity * subscription.product_infos.unit_price;
          all_full_prices = all_full_prices + subscription.quantity * subscription.product_infos.unit_price_onetime;

          const markup = `
            <div class="abonnement-summary__line_item">
                <div class="abonnement-summary__line_item-header">
                    <span class="abonnement-summary__line_item-title">
                      <span class="abonnement-summary__line_item-title-span">${subscription.product_infos.title}<span class="abonnement-summary__line_item-quantity">(x<span>${subscription.quantity}</span>)</span>
                    </span>
                    <span class="abonnement-summary__line_item-remove" data-item-remove="${subscription.variant_id}"><img src="https://cdn.shopify.com/s/files/1/2598/9270/files/unnamed.png?v=1681742149" alt=""></span>
                </div>
                <div class="abonnement-summary__line_item-middle">
                ${subscription.product_infos.vendor}
                </div>
                <div class="abonnement-summary__line_item-footer">
                    <span class="abonnement-summary__line_item-variant">${subscription.product_infos.variant_name}</span>
                    <span class="abonnement-summary__line_item-price">${(subscription.quantity * subscription.product_infos.unit_price).toFixed(2)}€</span>
                </div>
            </div>
          `;

          this.summaryLineItems.insertAdjacentHTML( 'beforeend', markup );          
        }
        

        this.summaryHeaderCounter.innerHTML = "(" + all_quantities + ")";

        document.querySelector('.abonnement-summary__add_to_cart-price').innerHTML = (all_prices.toFixed(2) + '€');
        document.querySelector(".abonnement-summary__loyalty span").innerHTML = Math.round(all_prices.toFixed(2) * 3)
        document.querySelector('[data-summary-header-price]').innerHTML = (all_prices.toFixed(2) + '€ | ');
        document.querySelector('.abonnement-summary__economy_price').innerHTML = ((all_full_prices - all_prices).toFixed(2) + '€');
      }
    }

    generateFrontQuantityAbonnementProduct(subscription) {
      for (var i = 0; i < this.abonnementProducts.length; i++) {
        var thisProductCard = this.abonnementProducts[i];

        var thisProductCardTitle = thisProductCard.getAttribute('data-product-name');
        if (thisProductCardTitle.replace(/\s+/g, '') == subscription.product_infos.title.replace(/\s+/g, '')) {
          var thisProductCardOptions = thisProductCard.querySelectorAll('.option2')
          for (let x = 0; x < thisProductCardOptions.length; x++) {
            const thisProductCardOption = thisProductCardOptions[x];
            if (thisProductCardOption.getAttribute('data-option-2') == subscription.product_infos.variant_name) {
              if (subscription.quantity != 0) {
                if (thisProductCardOption.nextElementSibling) {
                  thisProductCardOption.nextElementSibling.innerHTML = " (" + subscription.quantity + ")";
                }
              } else {
                thisProductCardOption.nextElementSibling.innerHTML = "";
              }
              
            }
          }
        }
        
      }
    }

    async addToCart() {
      //loop sur this.subcriptions
      //ajouter au panier

      var items = [];

      for (let index = 0; index < this.subcriptions.length; index++) {
        var subscription = this.subcriptions[index];
        var selling_plan_id = null;
        for (let j = 0; j < this.subcriptions[index].product_infos.sellings_plan.length; j++) {
          const selling_plan = this.subcriptions[index].product_infos.sellings_plan[j];
          if (String(this.frequency) === String(selling_plan.frequency)) {
            selling_plan_id = selling_plan.id;
          }
        }

        if (!selling_plan_id) {
          console.error('No selling plan found for frequency', this.frequency, subscription);
          continue;
        }

        items.push(
          {
            id: subscription.variant_id,
            quantity: subscription.quantity,
            selling_plan: selling_plan_id,
            properties: {
              "_shipping_interval_frequency": this.frequency,
              "_shipping_interval_unit_type": "Days",
            }
          }
        );
      }

      await this.updateOthersSubscriptions(this.frequency);
      

      // gtm

      CartJS.addItems(items, {

        // Define a success callback to display a success message.
        "success": async function(data, textStatus, jqXHR) {
          var gtmProduct = [];
          var snowplowProducts = [];
          for (let i = 0; i < data.items.length; i++) {
            const element = data.items[i];

            var rightProduct = document.querySelector('abonnement-product[data-product-name="'+ element.product_title +'"]');

            let detail = {
              sku: element.sku,
              handle: element.handle,
              quantity: parseInt(element.quantity),
              subscription: true,
              inventory_status: 'subscription',
              price: parseInt(element.price) * parseInt(element.quantity),
              creative: "Subscription Collection Page",
              product_type: element.product_type,
              currency: 'EUR'
            };

            //console.log('VD', detail);

            snowplowProducts.push(detail);

            gtmProduct.push({
                quantity : element.quantity.toString(),
                conditionnement : element.variant_options[0],
                taille : element.variant_options[1],
                addToCartType : 'Ajout au panier d\'un abonnement',
                id : element.product_id,
                name : element.untranslated_product_title,
                price : rightProduct.getAttribute('data-product-price'),
                type : element.product_type,
                productType : 'Abonnement',
                // list:productList,
                espece: rightProduct.getAttribute('data-product-espece'),
                stock: rightProduct.getAttribute('data-product-stock'),
                discount: rightProduct.getAttribute('data-product-discount'),
            });
          }

          var _cart = await (await fetch(`/cart.js`)).json();

          var params = {
            cartId : _cart.token,
            cartItem : _cart.item_count,
            cartTotal: _cart.total_price
          }

          gtmAddToCart(params, gtmProduct);

          multiAddToCartSnowPlow(snowplowProducts);

          function multiAddToCartSnowPlow(products) {
            let detail = {
              products: products
            };
            let event = new CustomEvent("hb_add_to_cart_multi", { detail: detail });
            window.dispatchEvent(event);
          }

          let itemRemoval = document.querySelectorAll('[data-summary-line-items] [data-item-remove]');
          for (let i = 0; i < itemRemoval.length; i++) {
            const _itemRemoval = itemRemoval[i];
            _itemRemoval.click();
          }

        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            
        }

      });

      this.summaryButtonAddToCart.classList.remove('loading');
    }

    

    removeOthersSubscriptions() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        try {
          var _cart = await (await fetch(`/cart.js`)).json();
          var subscriptions = {};
          subscriptions["updates"] = {};
    
          for (let i = 0; i < _cart.items.length; i++) {
            var element = _cart.items[i];
            if (element.properties.hasOwnProperty('_shipping_interval_frequency')) {
              subscriptions["updates"][element.key] = 0;
            }
          }

          await self.updateItemById(subscriptions);
          
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }

    updateOthersSubscriptions(newFrequency) {
      console.log('this',this)
      var self = this;
      return new Promise(async (resolve, reject) => {
        try {
          var _cart = await (await fetch(`/cart.js`)).json();
          var subscriptions = [];
    
          for (let i = 0; i < _cart.items.length; i++) {
            var element = _cart.items[i];
            if (element.properties.hasOwnProperty('_shipping_interval_frequency')) {
              subscriptions.push(
                {
                  "subscription_index": i + 1,
                  "subscription_key": element.key,
                  "subscription_variant_id": element.variant_id,
                  "subscription_handle": element.handle,
                  "subscription_quantity": element.quantity
                }
              );
            }
          }
    
          for (let index = 0; index < subscriptions.length; index++) {
            var handle = subscriptions[index].subscription_handle;
            var product = await this.getProduct(handle);
            console.log('product', product)

            var sellingPlans = product.selling_plan_groups[0].selling_plans;
            for (let j = 0; j < sellingPlans.length; j++) {
  
              if (sellingPlans[j].name.indexOf('Livraison tous les ' + newFrequency + ' jours') > -1) {
    
                var data = {
                  'properties': {
                    '_shipping_interval_frequency': newFrequency,
                    '_shipping_interval_unit_type': "Days"
                  },
                  'selling_plan': sellingPlans[j].id,
                  'line': subscriptions[index].subscription_index,
                  'quantity': subscriptions[index].subscription_quantity
                };

                await self.changeItemById(data);
  
              }
            }    
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }

    async getProduct(handle) {
      return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
      }).then(response => {
        return response.json();
      }).catch((error) => {
        console.error('Error:', error);
      });
    }

    async changeItem(data) {
      const result = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(data)
      });
    }
    
    changeItemById(data) {
      return this.changeItem(data);
    }

    async updateItem(data) {
      const result = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(data)
      });
    }
    
    updateItemById(data) {
      return this.updateItem(data);
    }
    

    openSummaryMobile(target) {
      target.classList.remove('active');
      target.nextElementSibling.classList.add('active');
      this.summaryOverlay.classList.add('active');
      this.summaryContent.style.maxHeight = this.summaryContent.scrollHeight +  "px";
    }

    closeSummaryMobile() {
      this.summaryContent.classList.remove('active');
      this.summaryOverlay.classList.remove('active');
      this.summaryContent.style.maxHeight = 0;
      if (this.subcriptions.length != 0) {
        this.summaryHeader.classList.add('active');
      }
    }

    dynamicListItemChanges(listItems, selectedItem) {
      for (let i = 0; i < listItems.children.length; i++) {
        let li = listItems.children.item(i);
        if (li) li.classList.remove('active');
      }
      selectedItem.classList.add('active');
    }

    getFrequenciesFromPlans(plans) {
      if (!plans || !plans.length) return [];

      var frequencies = [];
      for (let i = 0; i < plans.length; i++) {
        var value = String(plans[i].frequency == null ? '' : plans[i].frequency).trim();
        if (value && frequencies.indexOf(value) === -1) {
          frequencies.push(value);
        }
      }

      return frequencies.sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
    }

    intersectFrequencyLists(lists) {
      if (!lists.length) return [];

      return lists.reduce(function (common, list) {
        if (!common.length) return list.slice();
        return common.filter(function (value) {
          return list.indexOf(value) > -1;
        });
      }, lists[0].slice());
    }

    getFallbackFrequencies() {
      if (!this.dropdown) return [];
      var fallback = this.dropdown.getAttribute('data-fallback-frequencies') || '';
      return fallback.split(',').map(function (value) {
        return value.trim();
      }).filter(Boolean);
    }

    getDefaultFrequency(frequencies) {
      var preferred = this.dropdown
        ? (this.dropdown.getAttribute('data-default-frequency') || '30').trim()
        : '30';

      if (this.frequency && frequencies.indexOf(String(this.frequency)) > -1) {
        return String(this.frequency);
      }

      if (frequencies.indexOf(preferred) > -1) {
        return preferred;
      }

      return frequencies[0] || null;
    }

    getAvailableFrequencies() {
      var lists = [];

      if (this.subcriptions && this.subcriptions.length > 0) {
        for (let i = 0; i < this.subcriptions.length; i++) {
          var plans = this.subcriptions[i].product_infos && this.subcriptions[i].product_infos.sellings_plan;
          var freqs = this.getFrequenciesFromPlans(plans);
          if (freqs.length) lists.push(freqs);
        }
      }

      if (!lists.length && this.abonnementProducts) {
        for (let i = 0; i < this.abonnementProducts.length; i++) {
          try {
            var raw = this.abonnementProducts[i].getAttribute('data-abonnement-product-selling-plans');
            if (!raw) continue;
            var parsed = JSON.parse(raw);
            var pageFreqs = this.getFrequenciesFromPlans(parsed.sellings_plan);
            if (pageFreqs.length) lists.push(pageFreqs);
          } catch (error) {
            // Ignore malformed product selling-plan payloads.
          }
        }
      }

      if (!lists.length) {
        return this.getFallbackFrequencies();
      }

      var common = this.intersectFrequencyLists(lists);
      return common.length ? common : lists[0];
    }

    populateFrequenciesSelect(frequencies) {
      if (!this.dropdown || !this.selectBox) return;

      var dropList = this.dropdown.querySelector('ul.abonnement-summary__list-items');
      if (!dropList) return;

      var checkSvg = '<svg class="abonnement-summary__list-item-check" width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.7894 0.135709C16.6698 0.0364698 16.5155 -0.0114135 16.3604 0.00256854C16.2054 0.0165506 16.0622 0.0912557 15.9624 0.210288L6.69545 11.2809L1.87302 6.02375C1.68036 5.81299 1.41155 5.68711 1.12574 5.67381C0.839927 5.66051 0.560519 5.76088 0.348981 5.95284C0.137444 6.1448 0.0111048 6.41262 -0.00224236 6.69739C-0.0155895 6.98216 0.0851486 7.26055 0.277811 7.47131L5.93098 13.6418L5.95798 13.6699C6.05155 13.7708 6.16418 13.8523 6.2894 13.9098C6.41463 13.9673 6.55001 13.9997 6.68779 14.005C6.82558 14.0104 6.96307 13.9886 7.0924 13.9409C7.22173 13.8933 7.34036 13.8207 7.44152 13.7274C7.49299 13.6801 7.53945 13.6276 7.58018 13.5709L16.8876 0.932845C16.9757 0.81233 17.0146 0.662969 16.9964 0.514981C16.9781 0.366993 16.9042 0.231426 16.7894 0.135709Z" fill="white"/></svg>';

      this.selectBox.innerHTML = '';
      dropList.innerHTML = '';

      for (let i = 0; i < frequencies.length; i++) {
        var frequency = frequencies[i];
        var option = document.createElement('option');
        option.value = frequency;
        option.textContent = 'Tous les ' + frequency + ' jours';
        this.selectBox.appendChild(option);

        var li = document.createElement('li');
        li.className = 'abonnement-summary__list-item';
        li.setAttribute('data-value', frequency);
        li.innerHTML = 'Tous les ' + frequency + ' jours ' + checkSvg;
        dropList.appendChild(li);
      }

      var selected = this.getDefaultFrequency(frequencies);
      if (!selected) {
        this.frequency = null;
        if (this.selection) this.selection.innerHTML = '';
        return;
      }

      var selectedLi = dropList.querySelector('li[data-value="' + selected + '"]');
      this.selectBox.value = selected;
      this.frequency = selected;
      if (this.selection && selectedLi) {
        this.selection.innerHTML = selectedLi.innerHTML;
        this.dynamicListItemChanges(dropList, selectedLi);
      }
    }

    refreshFrequencies() {
      this.populateFrequenciesSelect(this.getAvailableFrequencies());
    }

    initFrequenciesSelect() {
      if (this.dropdown != null) {
        const dropList = this.dropdown.querySelector('ul.abonnement-summary__list-items');

        document.addEventListener('click', e => {
          if (!this.dropdown.contains(e.target)) {
            if (dropList.classList.contains('open')) {
              dropList.classList.remove('open');
            }
          }
        });

        this.dropdown.addEventListener('click', e => {
          if (dropList.classList.contains('open')) {
              dropList.classList.remove('open');
          } else {
              dropList.classList.add('open');
          }
          var selectedItem = e.target.closest('li[data-value]');
          if (selectedItem && dropList.contains(selectedItem)) {
              this.selectBox.value = selectedItem.dataset.value;
              this.frequency = selectedItem.dataset.value;
              this.selection.innerHTML = selectedItem.innerHTML;
              this.dynamicListItemChanges(dropList, selectedItem);
          }
        });

        this.refreshFrequencies();
      }
    }

    // UPDATE CART SNOWPLOW EVENT

    snowplowUpdateCart(handle, sku, qty, isSubscriptionProduct, isSubscription) {
      let detail = {
        handle: handle,
        sku: sku,
        quantity: 0,
        subscription: isSubscriptionProduct,
        inventory_status: isSubscription ? 'subscription' : 'oneoff',
        creative: "Subscription collection page"
      };
         
      let cartevent = new CustomEvent("hb_update_cart", { detail: detail });
        window.dispatchEvent(cartevent);
    }
  }
);


// quantity selector
customElements.define(
  'abonnement-product',
  class AbonnementProduct extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        productMinusBtn: "[data-product-minus]",
        productPlusBtn: "[data-product-plus]",
        maximumAttribute: 'data-product-maximum',
        productQuantity: "[data-product-quantity]",
        productAddToCartBtn: "[data-product-add-to-cart]",
        productVariantInput: "[data-product-variant-input]",
        productSellingsPlan: "[data-abonnement-product-selling-plans]",
        productSellingsPlanData: "abonnementProductSellingPlans",
        subscriptionSummary: "subscription-summary",
      };

      this.productMinusBtn = this.querySelector(this.selectors.productMinusBtn);
      this.productPlusBtn = this.querySelector(this.selectors.productPlusBtn);
      this.productQuantity = this.querySelector(this.selectors.productQuantity);
      this.productAddToCartBtn = this.querySelector(this.selectors.productAddToCartBtn);
      this.productVariantInputs = this.querySelectorAll(this.selectors.productVariantInput);
      this.subscriptionSummary = document.querySelector(this.selectors.subscriptionSummary);

      this.quantity = 0;
      this.addedVariants = [];
      this.temporaryAddingVariants = [];
      this.init();
    }

    init() {      
      this.productAddToCartBtn?.addEventListener('click', this.handleAddToCart.bind(this));
      this.productPlusBtn?.addEventListener('click', this.handleIncreaseQuantity.bind(this));
      this.productMinusBtn?.addEventListener('click', this.handleDecreaseQuantity.bind(this));
      this.productVariantInputs.forEach(input => input.addEventListener('change', this.handleVariantChange.bind(this)));
    }

    handleAddToCart() {

      const selectedVariants = this.querySelectorAll('.abonnement-product__variants-container input:checked');
      const productHandle = this.getAttribute('data-product-handle') || "";
      const variantSku = selectedVariants[0].getAttribute('data-product-variant-sku');

      if (selectedVariants.length === 0 && this.temporaryAddingVariants.length === 0) {
        this.displayTooltipMessage(this.productAddToCartBtn);
        return;
      }

      this.temporaryAddingVariants.forEach(element => {
        this.subscriptionSummary.updateSubscriptionSummary(element.variant_id, element.quantity, {
          title: element.product_infos.title,
          variant_name: element.product_infos.variant_name,
          vendor: element.product_infos.vendor,
          unit_price: element.product_infos.unit_price,
          unit_price_onetime: element.product_infos.unit_price_onetime,
          sellings_plan: element.product_infos.sellings_plan,
          sku: variantSku,
          handle: productHandle
        });
        this.addToCartSnowplow(element.quantity, variantSku, productHandle, true, true)
      });

      this.resetVariantsSelection();
      document.querySelector('[data-summary-header]').click();
    }

    // ADD TO CART SNOWPLOW EVENT

    addToCartSnowplow(quantity, sku, handle, isSubscriptionProduct, subscription) {

      let detail = {
        sku: sku,
        handle: handle,
        quantity: parseInt(quantity),
        subscription: isSubscriptionProduct,
        inventory_status: subscription ? 'subscription' : 'oneoff',
        creative: "Subscription Collection Page",
        currency: 'EUR'
      };

      

      let hb_event = new CustomEvent("hb_add_to_cart", { detail: detail });

      window.dispatchEvent(hb_event);
    }

    handleIncreaseQuantity() {
      const selectedVariantInput = this.querySelector('.abonnement-product__variants-container input:checked');
      if (!selectedVariantInput) {
        this.displayTooltipMessage(this.productPlusBtn);
        return;
      }

      const selectedVariantId = selectedVariantInput.value;
      const selectedOption = selectedVariantInput.nextElementSibling.querySelector('span.option2').textContent;
      const selectedTitle = this.querySelector('.abonnement-product__title')?.textContent || '';
      const selectedVendor = this.querySelector('.abonnement-product__vendor')?.textContent || '';
      const selectedSubscriptionPrice = selectedVariantInput.nextElementSibling.querySelector('span.price1').getAttribute('data-subscription-price-float');
      const selectedVariantPrice = selectedVariantInput.nextElementSibling.querySelector('span.price2').getAttribute('data-variant-price-float');

      this.quantity++;
      this.productQuantity.textContent = this.quantity;

      if (selectedVariantInput.hasAttribute('data-limited_order')) {
        const limit = selectedVariantInput.getAttribute('data-limited_order');
        if (this.quantity >= limit) {
          this.productPlusBtn.classList.add('product__qty-btn-disabled');
          document.querySelector('.product__tooltiptext').classList.add('active');
          setTimeout(() => document.querySelector('.product__tooltiptext').classList.remove('active'), 5000);
        }
      }

      if (!this.addedVariants.includes(selectedVariantId)) {
        this.addedVariants.push(selectedVariantId);
      }

      this.updateTemporaryAddingVariants(selectedVariantId, this.quantity, {
        title: selectedTitle,
        variant_name: selectedOption,
        vendor: selectedVendor,
        unit_price: selectedSubscriptionPrice,
        unit_price_onetime: selectedVariantPrice,
        sellings_plan: JSON.parse(this.dataset[this.selectors.productSellingsPlanData]).sellings_plan,
      });

      for (const element of this.temporaryAddingVariants) {
        this.subscriptionSummary.generateFrontQuantityAbonnementProduct(element);
      }
    }

    handleDecreaseQuantity() {
      const selectedVariantInput = this.querySelector('.abonnement-product__variants-container input:checked');
      if (!selectedVariantInput) {
        this.displayTooltipMessage(this.productMinusBtn);
        return;
      }

      const selectedVariantId = selectedVariantInput.value;

      if (this.quantity > 1) {
        this.quantity--;
        this.productQuantity.textContent = this.quantity;

        this.updateTemporaryAddingVariants(selectedVariantId, this.quantity, {
          title: this.querySelector('.abonnement-product__title')?.textContent || '',
          variant_name: selectedVariantInput.nextElementSibling.querySelector('span.option2').textContent,
          vendor: this.querySelector('.abonnement-product__vendor')?.textContent || '',
          unit_price: selectedVariantInput.nextElementSibling.querySelector('span.price1').getAttribute('data-subscription-price-float'),
          unit_price_onetime: selectedVariantInput.nextElementSibling.querySelector('span.price2').getAttribute('data-variant-price-float'),
          sellings_plan: JSON.parse(this.dataset[this.selectors.productSellingsPlanData]).sellings_plan,
        });

        if (selectedVariantInput.hasAttribute('data-limited_order')) {
          const limit = selectedVariantInput.getAttribute('data-limited_order');
          if (this.quantity < limit) {
            this.productPlusBtn.classList.remove('product__qty-btn-disabled');
          }
        }

        if (!this.addedVariants.includes(selectedVariantId)) {
          this.addedVariants = this.addedVariants.filter(id => id !== selectedVariantId);
        }
        for (const element of this.temporaryAddingVariants) {
          this.subscriptionSummary.generateFrontQuantityAbonnementProduct(element);
        }
      }
    }

    handleVariantChange() {      
      const selectedTitle = this.querySelector('.abonnement-product__title')?.textContent || '';
      const selectedOption = this.querySelector('.abonnement-product__variants-container input:checked + label span.option2')?.textContent || '';
      

      let findVariant = false;
      for (const element of this.temporaryAddingVariants) {
        if (selectedTitle.trim() === element.product_infos.title.trim() && selectedOption === element.product_infos.variant_name) {
          this.quantity = element.quantity;
          findVariant = true;
          break;
        } else {
          this.updateTemporaryAddingVariants(element.variant_id, 0, {});
          element.quantity = 0;
        }
      }

      if (!findVariant) {
        this.quantity = 0;
        this.productPlusBtn.click();
      }

      this.productQuantity.textContent = this.quantity;

      const selectedVariantInput = this.querySelector('.abonnement-product__variants-container input:checked');
      if (selectedVariantInput?.hasAttribute('data-limited_order')) {
        const limit = selectedVariantInput.getAttribute('data-limited_order');
        if (this.quantity < limit) {
          this.productPlusBtn.classList.remove('product__qty-btn-disabled');
        } else {
          this.productPlusBtn.classList.add('product__qty-btn-disabled');
        }
      } else {
        this.productPlusBtn.classList.remove('product__qty-btn-disabled');
      }
    }

    updateTemporaryAddingVariants(variant_id, quantity, product_infos) {
      const existingVariant = this.temporaryAddingVariants.find(v => v.variant_id === variant_id);
      if (existingVariant) {
        if (quantity === 0) {
          this.temporaryAddingVariants = this.temporaryAddingVariants.filter(v => v.variant_id !== variant_id);
        } else {
          existingVariant.quantity = quantity;
        }
      } else if (quantity > 0) {
        this.temporaryAddingVariants.push({ variant_id, quantity, product_infos });
      }
    }

    displayTooltipMessage(element) {
      element.classList.add("show-tooltip");
      setTimeout(() => element.classList.remove("show-tooltip"), 2000);
    }

    resetVariantsSelection() {
      this.temporaryAddingVariants = [];
      this.querySelectorAll('.abonnement-product__variants-container input:checked').forEach(input => {
        input.checked = false;
      });
      this.productQuantity.textContent = 1;
      this.quantity = 1;
      this.addedVariants = [];
    }
  }
);


// yotpo popup

/*customElements.define(
  'yotpo-popup',
  class yotpoPopup extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        "yotpoPopupContainer": "[data-yotpo-popup-container]",
        "yotpoPopupOverlay": "[data-yotpo-popup-overlay]",
        "yotpoPopupCloseButton": "[data-yotpo-popup-close]",
        "yotpoPopupStars": "[data-yotpo-popup-stars]",
        "yotpoPopupPageNumber": "[data-page-number]",
        "yotpoPopupNextPageButton": ".yotpo-popup__container-pagination__right-arrow",
        "yotpoPopupPreviousPageButton": ".yotpo-popup__container-pagination__left-arrow",
        "quizBannerContainer": ".quiz-banner__encart-product--container"
      }

      this.selectors = selectors;

      this.yotpoPopupContainer = this.querySelector(this.selectors.yotpoPopupContainer);
      this.yotpoPopupOverlay = this.querySelector(this.selectors.yotpoPopupOverlay);
      this.yotpoPopupCloseButton = this.querySelector(this.selectors.yotpoPopupCloseButton);
      this.yotpoPopupStars = this.querySelector(this.selectors.yotpoPopupStars);
      this.yotpoPopupPageNumber = this.querySelector(this.selectors.yotpoPopupPageNumber);
      this.yotpoPopupNextPageButton = this.querySelector(this.selectors.yotpoPopupNextPageButton);
      this.yotpoPopupPreviousPageButton = this.querySelector(this.selectors.yotpoPopupPreviousPageButton);
      this.product_id = this.getAttribute('data-popup-product-id');

      this.pageNumber = 1
      this.init();
    }

    init() {
      var self = this;

      // show the popup on click
      self.yotpoPopupStars.addEventListener('click', function() {
        self.open();
      })

      // hide the popup on click
      self.yotpoPopupOverlay.addEventListener('click', function() {
        self.close();
      })
      self.yotpoPopupCloseButton.addEventListener('click', function() {
        self.close();
      })


      
      // show reviews on popup
      var yotpo_url = 'https://api-cdn.yotpo.com/v1/widget/ib3UZsEMCWTakCBdQIiLYciJnTn4wbwvcu2EfhwC/products/' + self.product_id + '/reviews.json?sort=date&per_page=5';
      const yotpo_options = {
        method: 'GET',
        headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
      };

      Fetch();
      // pagination function
      self.yotpoPopupNextPageButton.addEventListener('click', function() {

        self.pageNumber = self.pageNumber + 1;
        yotpo_url = 'https://api-cdn.yotpo.com/v1/widget/ib3UZsEMCWTakCBdQIiLYciJnTn4wbwvcu2EfhwC/products/' + self.product_id + '/reviews.json?sort=date&per_page=5&page=' + self.pageNumber;
        self.yotpoPopupContainer.querySelector('.yotpo-popup__container-heading').remove();
        self.yotpoPopupContainer.querySelector('.yotpo-popup__container-reviews-container').remove();
        Fetch();
      })
      self.yotpoPopupPreviousPageButton.addEventListener('click', function() {
        self.pageNumber = self.pageNumber - 1;
        yotpo_url = 'https://api-cdn.yotpo.com/v1/widget/ib3UZsEMCWTakCBdQIiLYciJnTn4wbwvcu2EfhwC/products/' + self.product_id + '/reviews.json?sort=date&per_page=5&page=' + self.pageNumber;
        self.yotpoPopupContainer.querySelector('.yotpo-popup__container-heading').remove();
        self.yotpoPopupContainer.querySelector('.yotpo-popup__container-reviews-container').remove();
        Fetch();
      })

      function Fetch() { 
        fetch(yotpo_url, yotpo_options)
        .then(res => res.json())
        .then(json => {
          // heading informations
          var totalRate = (json.response.bottomline.average_score).toFixed(1);
          var reviewsNumber = json.response.bottomline.total_review;
          var starsNumber = Math.round(totalRate);
          var star = `
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7035_811)">
            <path d="M12.5009 0L16.3625 8.22984L25 9.5494L18.7514 15.9541L20.226 25L12.5009 20.7288L4.77398 25L6.25047 15.9541L0 9.5494L8.63746 8.22984L12.5009 0Z" fill="#628D83"/>
            </g>
            <defs>
            <clipPath id="clip0_7035_811">
            <rect width="25" height="25" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          `
          var starsContainer = '';
          for (let i = 0; i < starsNumber; i++) {
            starsContainer += star;
          }

          // reviews informations
          var reviewsContainer = '';
          for (let i = 0; i < json.response.reviews.length; i++) {
            var reviewContent = json.response.reviews[i]
            if (reviewContent == null) {
              return;
            }
            var reviewDate = reviewContent.created_at.split("T")[0].split("-");
            var reviewStarsNumber = reviewContent.score;
            var reviewStarsContainer = "";
            for (let i = 0; i < reviewStarsNumber; i++) {
              reviewStarsContainer += star;
            }
            var review = `
              <div class="yotpo-popup__container-review">
                <div class="yotpo-popup__container-review-stars-title-container">
                  <div class="yotpo-popup__container-review-stars">${reviewStarsContainer}</div>
                  <p class="yotpo-popup__container-review-title">${reviewContent.title}</p>
                </div>
                <p class="yotpo-popup__container-description">${reviewContent.content}</p>
                <p class="yotpo-popup__container-name-and-date"><span>${reviewContent.user.display_name} | </span><span>${reviewDate[2]}/${reviewDate[1]}/${reviewDate[0]}</span></p>
              </div>
            `

            reviewsContainer += review;
          }

          // generate html
          const markup = `
            <div class="yotpo-popup__container-heading">
              <p class="yotpo-popup__container-rate">${totalRate}</p>
              <div class="yotpo-popup__container-stars__container">
                <div class="yotpo-popup__container-stars">${starsContainer}</div>
                <p class="yotpo-popup__container-reviews-number">${reviewsNumber} AVIS</p>
              </div>
            </div>
            <div class="yotpo-popup__container-reviews-container">${reviewsContainer}</div>
          `;

          self.yotpoPopupContainer.insertAdjacentHTML( 'beforeend', markup );

          // pagination
          // self.pageNumber = json.response.pagination.page;
          var allPages = Math.ceil(json.response.pagination.total / 5);

          self.yotpoPopupPageNumber.innerHTML = "page " + self.pageNumber + " sur " + allPages;

          if (self.pageNumber == 1) {
            self.yotpoPopupContainer.querySelector('.yotpo-popup__container-pagination__left-arrow').classList.add('disable')
          } else if (self.pageNumber == allPages) {
            self.yotpoPopupContainer.querySelector('.yotpo-popup__container-pagination__right-arrow').classList.add('disable')
          } else {
            self.yotpoPopupContainer.querySelector('.yotpo-popup__container-pagination__left-arrow').classList.remove('disable')
            self.yotpoPopupContainer.querySelector('.yotpo-popup__container-pagination__right-arrow').classList.remove('disable')
          }
        })
        .catch(err => console.error('error:' + err));
      }
    }

    open() {
      if (document.querySelector(this.selectors.quizBannerContainer) != null) {
        document.querySelector(this.selectors.quizBannerContainer).classList.add('quiz-banner__encart-product--container--static');
      }
      this.yotpoPopupContainer.classList.remove('hide');
      this.yotpoPopupOverlay.classList.remove('hide');
      document.querySelector('body').classList.add('non-scroll');
    }

    close() {
      if (document.querySelector(this.selectors.quizBannerContainer) != null) {
        document.querySelector(this.selectors.quizBannerContainer).classList.remove('quiz-banner__encart-product--container--static');
      }
      this.yotpoPopupContainer.classList.add('hide');
      this.yotpoPopupOverlay.classList.add('hide');
      document.querySelector('body').classList.remove('non-scroll');
    }
  }
)
*/
